import { BREAKPOINTS } from '../utils/constants';
import scrollIntoViewWithOffset from '../utils/scrollIntoViewWithOffset';

const getMainAtcButton = () =>
  document.querySelector('[data-product-main] form')?.querySelector('button[type="submit"]') ?? null;

const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-btn]');
  if (!stickyAtcButton) return;

  const header = document.querySelector('.shopify-section-group-header-group');
  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  const variantInputEls = document.querySelectorAll('[data-variant-input]');
  const sellingPlanInputEls = document.querySelectorAll('[data-selling-plan-radio]');
  const productControlsEl = document.querySelector('[data-product-controls]');
  const selectEls = stickyAtc.querySelectorAll('[data-product-sticky-atc-select]');
  const form = document.querySelector('[data-product-main] form');
  const stickySectionContainer = stickyAtc.querySelector('[sticky-section-container]');
  const stickySections = document.querySelectorAll('[data-show-in-atc-bar]');
  const stickySectionButtons = [];

  const selectSection = (button) => {
    stickySectionButtons.forEach(other => other.removeAttribute('selected'));
    button.setAttribute('selected', 'selected');
    const headerOffset = header?.offsetHeight ?? 0;
    scrollIntoViewWithOffset(`#${button.dataset.target}`, stickyAtc.offsetHeight + headerOffset);
  };

  const buildLinks = () => {
    if (!stickySectionContainer || !stickySections.length) return;

    stickySections.forEach((section) => {
      const stickyButton = document.createElement('button');
      stickyButton.classList.add('sticky-atc-section');
      stickyButton.textContent = section.dataset.showInAtcBar;
      stickyButton.dataset.target = section.closest('section').id;
      stickySectionContainer.appendChild(stickyButton);
      stickySectionButtons.push(stickyButton);

      stickyButton.addEventListener('click', () => {
        selectSection(stickyButton);
      });
    });
  };

  const syncButtons = () => {
    const mainAtcButton = getMainAtcButton();
    if (!mainAtcButton) return;

    for (const name of stickyAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.removeAttribute(name);
      }
    }
    for (const name of mainAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.setAttribute(name, mainAtcButton.getAttribute(name));
      }
    }
    stickyAtcButton.innerHTML = mainAtcButton.innerHTML;
  };

  buildLinks();

  const mainAtcButton = getMainAtcButton();
  if (mainAtcButton) {
    syncButtons();
    const mainAtcBtnObserver = new MutationObserver(syncButtons);
    mainAtcBtnObserver.observe(mainAtcButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (productControlsEl) {
    const getBottom = el => el.getBoundingClientRect().top + window.scrollY + el.offsetHeight;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const containerBottom = getBottom(productControlsEl);
      if (scrollY >= containerBottom) {
        stickyAtc.classList.remove('hidden');
        stickyAtc.classList.add('z-10');
      } else {
        stickyAtc.classList.add('hidden');
        stickyAtc.classList.remove('z-10');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  stickyAtcButton.addEventListener('click', () => {
    const currentMainAtcButton = getMainAtcButton();
    if (desktopMediaQuery.matches && currentMainAtcButton) {
      currentMainAtcButton.click();
    } else if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (!variantInputEls.length && !sellingPlanInputEls.length) return;

  const allInputEls = [...variantInputEls, ...sellingPlanInputEls];

  const updateStickySelect = (variantInput) => {
    if (variantInput.checked === true) {
      selectEls.forEach(select => {
        if (select.name.includes(variantInput.name)) {
          select.value = variantInput.value;
        }
      });
    }
  };

  const updateStickyAtcVariant = (event) => {
    const target = event.target;
    allInputEls.forEach((inputEl) => {
      if (inputEl.value === target.value && target.name.includes(inputEl.name)) {
        inputEl.checked = true;
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  allInputEls.forEach(inputEl => {
    updateStickySelect(inputEl);

    inputEl.addEventListener('change', () => {
      updateStickySelect(inputEl);
    });
  });
  selectEls.forEach(select => select.addEventListener('change', updateStickyAtcVariant));
};

export default initProductStickyAtc;
